import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./pages/Home";
import Learning from "./pages/Learning";
import NotFound from "./pages/NotFound";
import { LanguageProvider, useLanguage } from "./i18n/LanguageContext";

// "/" has no content of its own: send visitors to their language's home page.
const RootRedirect = () => {
  const { language } = useLanguage();
  return <Navigate to={`/${language}`} replace />;
};

function App() {
  return (
    <Router>
      <LanguageProvider>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/id" element={<Home />} />
          <Route path="/en" element={<Home />} />
          <Route path="/learning" element={<Learning />} />
          <Route path="/learning/:id" element={<Learning />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </LanguageProvider>
    </Router>
  );
}

export default App;
